<template>
  <div></div>
  <!-- <div id="status-nav" class="bg-primary">
    <div class="container">
      <div
        class="d-flex align-items-center justify-content-between justify-content-md-end"
      >
        <div class="d-flex align-items-center">
          <div
            class="mr-2"
            style="line-height: 1px;"
            v-html="icons.points"
          ></div>
          <div class="mr-md-2">
            <strong>
              {{ $t("Level") }} {{ $store.getters.getUserLevel }}</strong
            >
            ({{ $store.getters.getUserPoints }}
            <span style="text-transform: lowercase;">pt</span>)
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div
            class="mr-2"
            style="line-height: 1px;"
            v-html="icons.coins"
          ></div>
          <div>
            <strong>{{ $store.getters.getUserCoins }}</strong> coins
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>
<script>
import iconCoins from "./../assets/svg/fnz_ize.svg";
import iconPoints from "./../assets/svg/fnz_point.svg";
export default {
  name: "status-nav",
  data() {
    return {
      icons: {
        coins: iconCoins,
        points: iconPoints
      }
    };
  },
  components: {
    iconCoins,
    iconPoints
  }
};
</script>
<style lang="scss" scoped>
#status-nav {
  position: static;
}
</style>
